export default __webpack_public_path__ + "static/wish-you-were-here-mobile-0a2bbe81ce70bde8174a0c43180353c0.webp";